"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  titleSearch: {
    title: '危险品 & 特种箱申请查询',
    refNo: '订舱号',
    placeholderRefNo: '请输入',
    validateNullRefNo: '订舱号不能为空'
  },
  dangerCargo: {
    result: '危险品查询',
    refNo: '订舱号',
    status: '状态',
    vvl: '航名航次',
    pol: '全程装港',
    pod: '全程卸港',
    mix: '是否混合',
    applyPerson: '申请人',
    applyDate: '申请时间',
    updateTime: '最后更新时间',
    CNTRQuantity: '箱量',
    IMOClass: '危险品等级',
    UNNo: '联合国编号'
  },
  speContainer: {
    result: '特种箱查询',
    refNo: '订舱号',
    status: '审批状态',
    vesselCode: '船舶代码',
    voyageNo: '航次',
    voyageLeg: '航段',
    pol: '装港',
    pod: '卸港',
    applyPerson: '申请人',
    applyDate: '申请时间',
    updateTime: '更新时间'
  }
};